import React from "react";
import jokerImage from '../assets/joker.png';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const PokerCard = ({card, wrapperClass = '', wrapperStyle = {}, isShowType = false, isShowPickedSymbol = false, isShowMoneySymbol = false}) => {
    if (!card || !card.cardId){
      return <div className={`card pokerCard`} draggable={false} style={{opacity: 0}}>
  </div>
    }

    const changeCardRank = (rank) => {
      return rank === '1' ? 'A' : rank === '11' ? 'J' : rank === '12' ? 'Q' : rank === '13' ? 'K' : rank;
    }
    
    const getCardTypeSymbol = (type) => {
      return type === 'spades' ? '\u2660' : type === 'hearts' ? '\u2665' : type === 'diamonds' ? '\u2666' : type === 'clubs' ? '\u2663' : '';
    }

    const statusMarkers = (isShowPickedSymbol || isShowMoneySymbol) &&
      <span className="card-status-markers" aria-hidden="true">
        {isShowPickedSymbol &&
          <span className="card-status-marker card-lock-marker">
            <EnhancedEncryptionIcon />
          </span>
        }
        {isShowMoneySymbol &&
          <span className="card-status-marker card-money-marker">
            <MonetizationOnIcon />
          </span>
        }
      </span>;

    return (
      card.type === 'jokers' ? (
        <div key={`${card.cardId}`} className={`poker-card-face joker-card ${card.rank} ${wrapperClass || ''}`} style={wrapperStyle} draggable={false}>
          <div className="joker-text">JOKER</div>
          <div className="joker-image"><img alt="" src={jokerImage} draggable={false}></img></div>
          {statusMarkers}
          <div className="joker-text-reverse">JOKER</div>
        </div>) : (
        <div key={`${card.cardId}`} className={`poker-card-face ${card.type} ${wrapperClass || ''}`} style={wrapperStyle} draggable={false}>
          <div className="pokerCard-rank-symbol">
            <span className="pokerCard-rank">{changeCardRank(card.rank)}</span>
            <span className="pokerCard-symbol">
              {getCardTypeSymbol(card.type)}
            </span>
          </div>
          {/* {isShowType && */}
            <span className="pokerCard-type" style={{display: isShowType ? 'flex' : 'none'}}>
              {getCardTypeSymbol(card?.type)}
            </span>
          {/* } */}
          {statusMarkers}
          <div className="pokerCard-rank-symbol-reverse">
            <span className="pokerCard-rank">{changeCardRank(card.rank)}</span>
            <span className="pokerCard-symbol">
              {getCardTypeSymbol(card.type)}
            </span>
          </div>
        </div>)
    )
  }

  export default PokerCard;
